import { render, staticRenderFns } from "./AlimentoSquare.vue?vue&type=template&id=01481cbc&"
import script from "./AlimentoSquare.vue?vue&type=script&lang=js&"
export * from "./AlimentoSquare.vue?vue&type=script&lang=js&"
import style0 from "./AlimentoSquare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports